/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAttachmentsClassStudents200,
  GetApiV1PersonIdAttachmentsClassStudents401,
  GetApiV1PersonIdAttachmentsClassStudents404,
  GetApiV1PersonIdAttachmentsClassStudents500,
  GetApiV1PersonIdAttachmentsClassStudentsPathParams,
  GetApiV1PersonIdAttachmentsClassStudentsQueryParams,
  GetApiV1PersonIdAttachmentsClassStudentsQueryResponse,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsClassStudents.ts";
import { classStudentDropDownItemViewModelSchema } from "../classStudentDropDownItemViewModelSchema.ts";

export const getApiV1PersonIdAttachmentsClassStudentsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonIdAttachmentsClassStudentsPathParams>;

export const getApiV1PersonIdAttachmentsClassStudentsQueryParamsSchema = z
  .object({
    companyId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1PersonIdAttachmentsClassStudentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAttachmentsClassStudents200Schema = z.array(
  z.lazy(() => classStudentDropDownItemViewModelSchema),
) as unknown as ToZod<GetApiV1PersonIdAttachmentsClassStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAttachmentsClassStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsClassStudents401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdAttachmentsClassStudents404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsClassStudents404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAttachmentsClassStudents500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsClassStudents500>;

export const getApiV1PersonIdAttachmentsClassStudentsQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonIdAttachmentsClassStudents200Schema,
  ) as unknown as ToZod<GetApiV1PersonIdAttachmentsClassStudentsQueryResponse>;
